import { motion } from 'framer-motion';
import '../../../styles/skills.css';

// Skill data with local images
import logo1  from '../../../assets/img/skills-logo/JavaScriptlogo.png';
import logo2  from '../../../assets/img/skills-logo/angularlogo.png';
import logo3  from '../../../assets/img/skills-logo/csslogo.png';
import logo4  from '../../../assets/img/skills-logo/htmllogo.png';
import logo5  from '../../../assets/img/skills-logo/ioniclogo.png';
import logo6  from '../../../assets/img/skills-logo/javalogo.png';
import logo7  from '../../../assets/img/skills-logo/mysqllogo.png';
import logo8  from '../../../assets/img/skills-logo/phplogo.png';
import logo9  from '../../../assets/img/skills-logo/pythonlogo.png';
import logo10 from '../../../assets/img/skills-logo/reactjslogo.png';
import logo11 from '../../../assets/img/skills-logo/springbootlogo.png';

const SKILLS = [
  { name: 'Java',        logo: logo6  },
  { name: 'Python',      logo: logo9  },
  { name: 'PHP',         logo: logo8  },
  { name: 'JavaScript',  logo: logo1  },
  { name: 'HTML',        logo: logo4  },
  { name: 'CSS',         logo: logo3  },
  { name: 'MySQL',       logo: logo7  },
  { name: 'ReactJS',     logo: logo10 },
  { name: 'Angular',     logo: logo2  },
  { name: 'Ionic',       logo: logo5  },
  { name: 'Spring Boot', logo: logo11 },
];

const containerVariants = {
  hidden:  {},
  visible: { transition: { staggerChildren: 0.06 } },
};

const cardVariants = {
  hidden:  { opacity: 0, y: 20, scale: 0.96 },
  visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.45, ease: [0.25, 0.46, 0.45, 0.94] } },
};

const textVariants = {
  hidden:  { opacity: 0, x: -20 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.6, ease: [0.25, 0.46, 0.45, 0.94] } },
};

export function Skills() {
  return (
    <section className="skills" id="skills" aria-label="Skills">
      <div className="skills-container">

        {/* Section header */}
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.55 }}
        >
          <span className="section-eyebrow">What I work with</span>
          <h2 className="section-title">Skills & Technologies</h2>
          <span className="accent-line" aria-hidden="true" />
        </motion.div>

        <div className="skills-layout">

          {/* ---- Bio text ---- */}
          <motion.div
            className="skills-bio"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-60px' }}
            variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.15 } } }}
          >
            <motion.p variants={textVariants}>
              I'm a Computer Science graduate from Mapúa University, specializing in
              Application Development. Throughout my academic journey, I've built
              projects across multiple languages and frameworks, developing a solid
              foundation in both front-end and back-end development.
            </motion.p>
            <motion.p variants={textVariants}>
              My experience spans full-stack web development, mobile app creation with
              Ionic and Angular, and server-side development with Java Spring Boot and
              PHP. I enjoy building products that are clean, performant, and genuinely
              useful.
            </motion.p>
          </motion.div>

          {/* ---- Skill cards ---- */}
          <motion.div
            className="skills-grid"
            role="list"
            aria-label="Technology skills"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-60px' }}
          >
            {SKILLS.map(({ name, logo }) => (
              <motion.div
                key={name}
                className="skill-card"
                role="listitem"
                variants={cardVariants}
                whileHover={{ y: -4 }}
                title={name}
              >
                <div className="skill-card-icon">
                  <img src={logo} alt={`${name} logo`} loading="lazy" />
                </div>
                <span className="skill-card-name">{name}</span>
              </motion.div>
            ))}
          </motion.div>

        </div>
      </div>
    </section>
  );
}
